/**
 * Publishes a Shopify custom event when a homepage banner link is clicked.
 * The banner's tracking name is read from `data-banner-name` on the `[data-banner-track]` wrapper.
 * Subscribe in a Customer Events pixel with `analytics.subscribe('Homepage Banner', ...)`.
 */
(function () {
  const EVENT_NAME = 'Homepage Banner';
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('a[href]');
      if (!link) return;

      const wrapper = link.closest('[data-banner-track]');
      if (!wrapper) return;

      const publish = window.Shopify?.analytics?.publish;
      if (typeof publish !== 'function') return;

      const bannerName = wrapper.dataset.bannerName || '';
      if (!bannerName) return;

      const img = wrapper.querySelector('img');

      try {
        publish(EVENT_NAME, {
          banner_name: bannerName,
          device: MOBILE_QUERY.matches ? 'mobile' : 'desktop',
          // Query string dropped so the value stays under GA4's 100-character parameter limit.
          image_url: img ? (img.currentSrc || img.src).split('?')[0] : '',
          link_url: link.href,
        });
      } catch {}
    },
    true
  );
})();
